import { useMemo } from "react";
import { useStore } from "react-redux";

import { CustomerType } from "../constants";
import { PlacesSearchEngine, StopsSearchEngine } from "../search";

import useAppSelector from "./useAppSelector";

import type { SearchEngine } from "../search";

/**
 * Returns the search engines available for the current customer:
 * stops (mobility customers only, prioritized) and places (all customers).
 */
const useSearchEngines = (mots?: string): SearchEngine[] => {
  const store = useStore();
  const customerType = useAppSelector((state) => {
    return state.app.config.customerType || CustomerType.MOBILITY;
  });
  const settings = useAppSelector((state) => {
    return state.app.config.settings;
  });
  const prefAgencies = useAppSelector((state) => {
    return state.app.prefAgencies;
  });
  const geoapifyKey = useAppSelector((state) => {
    return state.app.geoapifyKey as string;
  });

  return useMemo(() => {
    const engines: SearchEngine[] = [];

    engines.push(
      new StopsSearchEngine({
        params: {
          bbox: settings?.stops_api_bbox || "",
          mots: mots || "",
          prefagencies: settings?.stops_api_prefagencies || prefAgencies,
        },
        priority: 0,
        store,
      }),
    );
    if (customerType !== CustomerType.MOBILITY) {
      if (geoapifyKey) {
        engines.push(
          new PlacesSearchEngine({ apiKey: geoapifyKey, priority: 1 }),
        );
      }
    }
    return engines;
  }, [customerType, geoapifyKey, mots, prefAgencies, settings, store]);
};

export default useSearchEngines;
